import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <header className="relative pt-24 md:pt-8 pb-12 lg:py-32 overflow-hidden min-h-[90vh] flex items-center">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          alt="Smile Care Dental Clinic Interior"
          className="w-full h-full object-cover"
          src="/images/hero-bg.png"
        />
        {/* Elegant Gradient: Light warm overlay for better text contrast */}
        <div className="absolute inset-0 bg-gradient-to-r from-background-light/95 via-background-light/90 to-transparent dark:from-background-dark/95 dark:via-background-dark/90 dark:to-transparent"></div>
      </div>

      <div className="container mx-auto px-6 md:px-12 relative z-10 w-full">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 backdrop-blur-sm text-primaryDark dark:text-primary text-sm font-semibold tracking-wide uppercase mb-8">
            <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
            Premier Dental Care in Kottawa, Sri Lanka
          </div>

          {/* Main Headline - Serif Font */}
          <h1 className="font-display text-4xl md:text-5xl lg:text-7xl font-bold text-slate-900 dark:text-white leading-[1.1] mb-6">
            Crafting Sri Lanka’s <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary italic pr-2">
              Most Confident Smiles
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg lg:text-xl text-slate-600 dark:text-slate-300 mb-10 leading-relaxed max-w-2xl font-light">
            Experience world-class dentistry with a touch of Sri Lankan hospitality.
            From affordable dental implants to advanced cosmetic procedures, your journey to a perfect smile starts at Kottawa's leading dental surgery.
          </p>

          {/* CTA Buttons - Premium Style */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-5">
            <a
              href="tel:+94777880894"
              className="bg-primary hover:bg-primaryDark text-white px-8 py-4 rounded-full font-bold shadow-lg hover:shadow-glow transition-all duration-300 flex items-center justify-center gap-3 group"
            >
              <i className="fas fa-phone-alt text-xl"></i>
              Book an Appointment
              <i className="fas fa-arrow-right group-hover:translate-x-1 transition-transform"></i>
            </a>

            <Link
              to="/treatments"
              className="bg-white dark:bg-slate-800/50 text-slate-700 dark:text-white border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 px-8 py-4 rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 backdrop-blur-sm"
            >
              Explore Treatments
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex items-center gap-8 text-sm font-medium text-slate-500 dark:text-slate-400">
            <div className="flex items-center gap-2">
              <i className="fas fa-check-circle text-secondary"></i>
              <span>Modern Technology</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="fas fa-check-circle text-secondary"></i>
              <span>Certified Specialists</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="fas fa-check-circle text-secondary"></i>
              <span>COVID-19 Safe</span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
